export function matchType(str, query) {
  if (query.length > str.length) {
    return 'none';
  }
  if (str === query) {
    return 'exact';
  }
  if (str.startsWith(`${query} `)) {
    return 'word from beginning';
  }
  if (str.startsWith(`${query}`)) {
    return 'substring from beginning';
  }
  if (str.includes(` ${query} `)) {
    return 'word';
  }
  if (str.endsWith(` ${query}`)) {
    return 'word';
  }
  if (str.includes(` ${query}`)) {
    return 'substring';
  }
  return 'none';
}
const characterSubstitutions = [
// Swedish keyboards
// TODO: We should look into `base` sensitivity for the comparison
{
  from: 'ö',
  to: 'ø'
}, {
  from: 'ä',
  to: 'æ'
},
// Norwegian keyboards with US layout (yes, this is a real thing)
{
  from: "'",
  to: 'æ'
}, {
  from: ';',
  to: 'ø'
}, {
  from: '\\[',
  to: 'å'
}, {
  from: '"',
  to: 'æ'
},
// capital Æ
{
  from: ':',
  to: 'ø'
},
// capital Ø
{
  from: '\\{',
  to: 'å'
} // capital Å
].map(({
  from,
  to
}) => ({
  from: new RegExp(from, 'g'),
  to
}));
export function substituteCharacters(lowerCaseQuery) {
  return characterSubstitutions.reduce((query, {
    from,
    to
  }) => query.replace(from, to), lowerCaseQuery);
}
export function queryMatches(str, query) {
  return matchType(str.toLowerCase(), query.toLowerCase()) !== 'none';
}
//# sourceMappingURL=utils.js.map